import Reflux from 'reflux';
import difference from 'lodash/difference';
import unique from 'lodash/uniq';

import actions from '../actions';
import configurationStore from './configuration-store';
import stateStore from './state-store';
import accessoryStateStore from './accessory-state-store';

export default Reflux.createStore({
	listenables: actions,

	init() {
		this.listenTo(configurationStore, this.onConfigurationChange);
		this.listenTo(stateStore, this.onStateChange);
		this.listenTo(accessoryStateStore, this.onAccessoryStateChange);

		this.state = {
			apiUrl: '',
			languageCode: 'en',
			showDisabled: false,

			items: {
				// configuration
				properties: [],
				pinningFacetIds: [],
				defaultFacets: [],
				visibleFacets: [],
				compositions: [],

				// state
				userSelection: {},
			},

			accessories: {
				// configuration
				properties: [],
				pinningFacetIds: [],
				visibleFacets: [],
				idsForItems: [],
				compositions: [],

				// state
				userSelection: {}
			}
		};
		console.log('apiStore init', this.state);
	},

	onConfigurationChange(configuration) {
		this.state.apiUrl = configuration.apiUrl;
		this.state.showDisabled = configuration.showDisabled;
		this.state.languageCode = configuration.languageCode;

		// items
		this.state.items.properties = configuration.properties || [];
		this.state.items.defaultFacets = configuration.defaultFacets || [];
		this.state.items.visibleFacets = configuration.visibleFacets || [];
		this.state.items.compositions = configuration.compositions || [];

		// accessories
		this.state.accessories.properties = configuration.accessories.properties || [];
		this.state.accessories.visibleFacets = configuration.accessories.visibleFacets || [];
		this.state.accessories.compositions = configuration.accessories.compositions || [];

		console.log('apiStore onConfigurationChange', this.state);
		this.output();
	},

	onStateChange(state) {
		this.output();
	},

	onAccessoryStateChange(state) {
		this.output();
	},

	onLoadAccessoryIdsForItemsCompleted(data) {
		this.state.accessories.idsForItems = data.body;
		this.output();
	},

	getState() {
		return {
			preselection: {
				selected: this.state.items.properties,
				visible: this.state.items.pinningFacetIds
			},
			accessories: {
				selected: this.state.accessories.properties,
				visible: difference(unique(this.state.accessories.visibleFacets), this.state.accessories.pinningFacetIds),
				itemList: this.state.accessories.idsForItems, // TODO: exclude pinningFacetIds
				compositions: this.state.accessories.compositions
			},
			accessoriesPreselection: {
				selected: this.state.accessories.properties,
				visible: this.state.accessories.pinningFacetIds,
				itemList: this.state.accessories.idsForItems // TODO: exclude pinningFacetIds
			},
			apiUrl: this.state.apiUrl,
			languageCode: this.state.languageCode,
			showDisabled: this.state.showDisabled
		};
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
